export const rolplaySteps = [
  {
    element: '#rolplay-tabs',
    popover: {
      title: 'Pestañas de Tareas',
      description: 'Alterna entre tareas completadas y pendientes',
      position: 'bottom'
    }
  },
  {
    element: '#rolplay-search',
    popover: {
      title: 'Buscador',
      description: 'Busca por cualquier campo como nombre, actividad o ejercicio',
      position: 'bottom'
    }
  },
  {
    element: '#rolplay-table',
    popover: {
      title: 'Tabla de Actividades',
      description: 'Vista detallada de todas las actividades y su información',
      position: 'bottom'
    }
  },
  {
    element: '#rolplay-date-filter',
    popover: {
      title: 'Filtro de Fechas',
      description: 'Filtra los resultados por rango de fechas específico',
      position: 'top'
    }
  },
  {
    element: '#rolplay-download',
    popover: {
      title: 'Descargar Datos',
      description: 'Exporta los datos filtrados a un archivo CSV',
      position: 'left'
    }
  }
];

export const simulatorSteps = [
  {
    element: '#simulator-search',
    popover: {
      title: 'Buscador',
      description: 'Encuentra simulaciones específicas usando cualquier dato',
      position: 'bottom'
    }
  },
  {
    element: '#simulator-table',
    popover: {
      title: 'Tabla de Simulaciones',
      description: 'Vista detallada de todas las simulaciones realizadas',
      position: 'bottom'
    }
  },
  {
    element: '#simulator-date-filter',
    popover: {
      title: 'Filtro de Fechas',
      description: 'Filtra simulaciones por rango de fechas',
      position: 'top'
    }
  },
  {
    element: '#simulator-download',
    popover: {
      title: 'Exportar Datos',
      description: 'Descarga los resultados en formato CSV',
      position: 'left'
    }
  }
];

export const dashboardSteps = [
  {
    element: '#dashboard-metrics',
    popover: {
      title: 'Métricas Principales',
      description: 'Resumen de las estadísticas más importantes',
      position: 'bottom'
    }
  },
  {
    element: '#dashboard-categories',
    popover: {
      title: 'Distribución de Categorías',
      description: 'Visualización del progreso por categoría de usuario',
      position: 'top'
    }
  }
];
